import {
  consignmentContractService,
  fetchConsignmentContractTabData,
  type ConsignmentContractDetail,
  type UserContractInfo,
} from '@/entities/contract/api/consignment-contract.api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const consignmentContractKeys = {
  all: ['consignment-contracts'] as const,
  tab: (userId?: number, email?: string) =>
    [...consignmentContractKeys.all, 'tab', userId, email] as const,
  signedHtml: (contractId: string) =>
    [...consignmentContractKeys.all, 'signed-html', contractId] as const,
};

export const useConsignmentContractTab = ({
  enabled,
  userId,
  email,
  contractInfo,
}: {
  enabled: boolean;
  userId?: number;
  email?: string;
  contractInfo?: UserContractInfo | null;
}) =>
  useQuery({
    queryKey: consignmentContractKeys.tab(userId, email),
    queryFn: () =>
      fetchConsignmentContractTabData({ userId, email, contractInfo }),
    enabled: enabled && Boolean(userId || email),
  });

export const useApplyConsignmentReview = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: consignmentContractService.applyConsignmentReview,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consignmentContractKeys.all });
    },
  });
};

export const useContractSignedHtml = (
  contractId: string | null | undefined,
  enabled: boolean,
) =>
  useQuery({
    queryKey: consignmentContractKeys.signedHtml(contractId ?? ''),
    queryFn: () =>
      consignmentContractService.fetchSignedHtmlContent(String(contractId)),
    enabled: enabled && Boolean(contractId),
    // 서명 전·권한 없음(403)을 같은 요청으로 반복하지 않는다
    retry: false,
  });

export type { ConsignmentContractDetail, UserContractInfo };
